import React, { useState, useEffect } from 'react';
import Modal, { Footer } from '@/components/common/Modal';
import { GET_SLIDE_OBJECT } from '@/components/admin/SlideShow/Utils/slideShowGraphQL';
import { useQuery } from '@apollo/client';
import useSlideShowContext from '@/components/admin/SlideShow/stores/useSlideShowContext';
import { plato_api_set_section_slide_object_path } from '@/modules/routes';
import Axios from 'axios';
import { slideObjectPropTypes } from '@/components/admin/SlideShow/Utils/index';
import SectionsSelect from
  '../SlideObjectText/CustomFroalaCommands/ElementInsert/ModalInputs/Components/SectionsSelect';

interface ReadingSelectModalProps {
  modalManager: ModalManager;
  slideObject: slideObjectPropTypes;
}

const ReadingSelectModal = ({ modalManager, slideObject }: ReadingSelectModalProps) => {
  const [selectedSection, setSelectedSection] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  const programId = useSlideShowContext(state => state.programId);
  const updateSlideObject = useSlideShowContext(state => state.updateSlideObject);

  useEffect(() => {
    if (!slideObject.html) {
      setIsEditing(false);
      return;
    }

    const isIframe = slideObject.modelType === 'Section';

    // Extract the data-section-id from the HTML string
    const dataSectionIdMatch = isIframe ? slideObject.html.match(/data-section-id="([^"]+)"/) : slideObject.modelId;

    if (dataSectionIdMatch) {
      const dataSectionId = isIframe ? parseInt(dataSectionIdMatch[1], 10) : dataSectionIdMatch;
      setIsEditing(true);
      setSelectedSection(dataSectionId);
    } else {
      setIsEditing(false);
      setSelectedSection(null);
    }
  }, [modalManager.isOpen]);

  const { refetch: getSlideObject } = useQuery(GET_SLIDE_OBJECT, {
    fetchPolicy: 'network-only',
    skip: true,
  });

  const refetchSlideObject = async () => {
    const { data } = await getSlideObject({ id: slideObject.id });
    updateSlideObject(data.slideObject);
  };

  const handleSubmit = () => {
    Axios.post(plato_api_set_section_slide_object_path(slideObject.id), {
      program_id: programId,
      section_id: selectedSection,
    }).then(() => {
      refetchSlideObject();
    }).then(() => {
      modalManager.close();
    });
  };

  return (
    <Modal
      headerText={isEditing ? 'Edit Reading' : 'Add Reading'}
      {...modalManager}
      bodyClassName="tw-overflow-hidden"
      closeModal={modalManager.close}
    >
      <SectionsSelect
        multiSelect={false}
        sectionId={selectedSection}
        sectionType="Lesson"
        setSectionIds={setSelectedSection}
      />
      <Footer
        primaryButtonCallback={handleSubmit}
        primaryButtonDisabled={!selectedSection}
        primaryButtonSubmit={false}
        primaryButtonText="Submit"
        secondaryButtonCallback={() => modalManager.close()}
      />
    </Modal>
  );
};

export default ReadingSelectModal;
